<div class="pm-overlay" [class.open]="showPasswordModal()" (click)="closed.emit()"></div>
<div class="pm cpw-modal" [class.open]="showPasswordModal()" (click)="$event.stopPropagation()">

  <div class="pm-top">
    <div class="pm-top-left">
      <div class="cpw-icon-wrap">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" width="28" height="28">
          <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
      </div>
      <div class="pm-top-info">
        <h2 class="pm-name">{{ 'AUTH.CHANGE_PASSWORD' | translate }}</h2>
        <span class="pm-role">{{ currentUser()?.email }}</span>
      </div>
    </div>
    <button class="pm-close" (click)="closed.emit()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>

  <div class="pm-divider"></div>

  <div class="cpw-body">
    @if (pwdError()) {
      <div class="cpw-error">
        <i class="pi pi-exclamation-circle"></i> {{ pwdError() }}
      </div>
    }

    <div class="pm-field">
      <label><i class="pi pi-lock"></i> {{ 'AUTH.CURRENT_PASSWORD' | translate }}</label>
      <div class="cpw-input-wrap">
        <input [type]="showCurrentPwd() ? 'text' : 'password'" class="pm-input" [(ngModel)]="currentPwd"
               [placeholder]="'AUTH.CURRENT_PASSWORD' | translate" />
        <button class="cpw-eye" type="button" (click)="showCurrentPwd.set(!showCurrentPwd())">
          <i class="pi" [ngClass]="showCurrentPwd() ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="pm-field">
      <label><i class="pi pi-lock"></i> {{ 'AUTH.NEW_PASSWORD' | translate }}</label>
      <div class="cpw-input-wrap">
        <input [type]="showNewPwd() ? 'text' : 'password'" class="pm-input" [(ngModel)]="newPwd"
               [placeholder]="'AUTH.NEW_PASSWORD' | translate" />
        <button class="cpw-eye" type="button" (click)="showNewPwd.set(!showNewPwd())">
          <i class="pi" [ngClass]="showNewPwd() ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="pm-field">
      <label><i class="pi pi-lock"></i> {{ 'AUTH.CONFIRM_PASSWORD' | translate }}</label>
      <div class="cpw-input-wrap">
        <input [type]="showConfirmPwd() ? 'text' : 'password'" class="pm-input" [(ngModel)]="confirmPwd"
               [placeholder]="'AUTH.CONFIRM_PASSWORD' | translate"
               (keydown.enter)="submitted.emit()" />
        <button class="cpw-eye" type="button" (click)="showConfirmPwd.set(!showConfirmPwd())">
          <i class="pi" [ngClass]="showConfirmPwd() ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="cpw-hint">
      <i class="pi pi-info-circle"></i>
      {{ 'AUTH.PASSWORD_HINT' | translate }}
    </div>
  </div>

  <div class="pm-divider"></div>

  <div class="pm-footer">
    <button class="pm-btn-cancel" (click)="closed.emit()">
      {{ 'COMMON.CANCEL' | translate }}
    </button>
    <button class="pm-btn-save" (click)="submitted.emit()" [disabled]="pwdSaving()">
      @if (pwdSaving()) {
        <i class="pi pi-spin pi-spinner"></i>
      }
      <i class="pi pi-check"></i> {{ 'COMMON.SAVE' | translate }}
    </button>
  </div>
</div>
